//

// export const baseUrl_back = 'http://127.0.0.1:8000'
export const baseUrl_back = 'https://dmf2024.rezus.pro/'
